<template>
	<div
		:class="['single-sort', disabled && 'is-disabled']"
		:variant="variant"
		:id="uid"
	>
		<div
			:class="['single-sort__container']"
			v-for="(item, index) in items"
			:key="index"
		>
			<input
				type="radio"
				name="radioSort"
				class="single-sort__input"
				:id="`${uid}_${index}`"
				:checked="item.value == value"
				:value="item.value"
				@input="$emit('change', item.value)"
			/>
			<label
				:for="`${uid}_${index}`"
				class="single-sort__label"
				:tabindex="index"
			>
				<slot :name="item.slotName"></slot>
			</label>
		</div>
	</div>
</template>

<script>
/*
Usage
	import Singlesort from '@/components/forms/single-sort/single-sort';

	<Singlesort
		:disabled= "Boolean" --Determine the enabled property of the component
		:value= "String" --Determine the selected value in the component. 	
		@click="Event" --Determine the event emitted in the component 
	/>
*/
export default {
	name: 'Singlesort',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: String,
			default: 'asc'
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			items: [
				{ value: 'asc', slotName: 'label1' },
				{ value: 'desc', slotName: 'label2' }
			]
		};
	}
};
</script>

<style lang="scss" scoped>
/**
	* Single Sort styles
	* Can use SCSS variables = TRUE
*/

@import '@/scss/5-objects/_form.scss';

.single-sort {
	border: $form-input-border;
	border-radius: $form-border-radius;
	display: inline-flex;
	flex-wrap: nowrap;
}
.single-sort__container {
	position: relative;

	.single-sort__input {
		display: none;
		position: relative;

		&:checked {
			& + .single-sort__label {
				background-color: $btn-primary-bkgd;
				@include text-contrast($btn-primary-bkgd, $white, $black);
				border-radius: initial;
			}
		}
	}

	.single-sort__label {
		display: inline-block;
		width: 100%;
		@include input-height;
		padding: $input-padding-y $input-padding-x;
		font-size: $btn-font-size;
		color: $neutral-3;
		background-color: $white;
		border-radius: $form-border-radius;
		cursor: pointer;

		&:focus {
			-o-outline: $focus-outline;
			-moz-outline: $focus-outline;
			outline: $focus-outline;
			outline-offset: $focus-offset;
		}
	}
}
</style>
